export const querySFTPProcessingsByStatusCreatedDateIndex = `
query QuerySFTPProcessingsByStatusCreatedDateIndex(
  $status: String!
  $first: Int
  $after: String
) {
  querySFTPProcessingsByStatusCreatedDateIndex(
    status: $status
    first: $first
    after: $after
  ) {
    items {
      id
      alertSent
      file
      companyId
      companyName
      createdDate
      endDate
      logs
      status
      startDate
      syncType
      processName
      processId
      processTime
      processTimeInQueue
      result
    }
    nextToken
  }
}
`;